import {NavigationBar} from "../home/NavigationBar";

export const AppHeader = () => {
    return (
        <header>
            <NavigationBar />
        </header>
    );
};








